
import LanguageService from './LanguageService';

export { default } from './LanguageService';
export const languageService = new LanguageService();